import React from 'react';
import PropTypes from 'prop-types';

import ResizedImage from 'rebook/apps/utils/components/ResizedImage';

import styles from './style.scss';


const CatalogItemImage = ({ imageSrc, alt, height, width }) => (
  <div className={styles.imageBlock}>
    {imageSrc && (
      <ResizedImage
        className={styles.image}
        height={height}
        width={width}
        src={imageSrc}
        alt={alt} />
    )}
  </div>
);

CatalogItemImage.propTypes = {
  imageSrc: PropTypes.string,
  alt: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

CatalogItemImage.defaultProps = {
  height: '96',
  width: '96',
};

export default CatalogItemImage;
